import { React, useState } from 'react';
import {
    Box,
    Button,
    Container,
    FormControl,
    InputAdornment,
    Grid,
    TextField,
    Typography,
    IconButton,
    Paper
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;

function OrganizationRegister() {

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        organization_name: '',
        organization_short_name: '',
        organization_phone_no: '',
        organization_address: '',
        organization_city: '',
        organization_country: '',
        organization_postal_code: ''
    });

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };
    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handleRegister = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const validationErrors = {};
        for (const key in formData) {
            if (!formData[key]) {
                validationErrors[key] = `${key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} is required`;
            }
        }

        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            setIsLoading(false);
            return;
        }

        await fetch(`${BASE_URL}/auth/register_organization`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setIsLoading(false);
                    toast.success('Organization registered successfully');
                } else {
                    setIsLoading(false);
                    toast.error(data.error);
                }
            });
    };

    return (
        <CoverLayout image={bgImage}>
            <ToastContainer />
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Register Your Organization
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="first_name"
                                    name="first_name"
                                    label="First Name"
                                    variant="outlined"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    error={!!errors.first_name}
                                    helperText={errors.first_name}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="last_name"
                                    name="last_name"
                                    label="Last Name"
                                    variant="outlined"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    error={!!errors.last_name}
                                    helperText={errors.last_name}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="email"
                                    name="email"
                                    label="Email Address"
                                    variant="outlined"
                                    value={formData.email}
                                    onChange={handleChange}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_name"
                                    name="organization_name"
                                    label="Organization Name"
                                    variant="outlined"
                                    value={formData.organization_name}
                                    onChange={handleChange}
                                    error={!!errors.organization_name}
                                    helperText={errors.organization_name}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_short_name"
                                    name="organization_short_name"
                                    label="Organization Short Name"
                                    variant="outlined"
                                    value={formData.organization_short_name}
                                    onChange={handleChange}
                                    error={!!errors.organization_short_name}
                                    helperText={errors.organization_short_name}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_phone_no"
                                    name="organization_phone_no"
                                    label="Organization Phone No"
                                    variant="outlined"
                                    value={formData.organization_phone_no}
                                    onChange={handleChange}
                                    error={!!errors.organization_phone_no}
                                    helperText={errors.organization_phone_no}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_address"
                                    name="organization_address"
                                    label="Organization Address"
                                    variant="outlined"
                                    value={formData.organization_address}
                                    onChange={handleChange}
                                    error={!!errors.organization_address}
                                    helperText={errors.organization_address}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_city"
                                    name="organization_city"
                                    label="Organization City"
                                    variant="outlined"
                                    value={formData.organization_city}
                                    onChange={handleChange}
                                    error={!!errors.organization_city}
                                    helperText={errors.organization_city}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_country"
                                    name="organization_country"
                                    label="Organization Country"
                                    variant="outlined"
                                    value={formData.organization_country}
                                    onChange={handleChange}
                                    error={!!errors.organization_country}
                                    helperText={errors.organization_country}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="organization_postal_code"
                                    name="organization_postal_code"
                                    label="Organization Postal Code"
                                    variant="outlined"
                                    value={formData.organization_postal_code}
                                    onChange={handleChange}
                                    error={!!errors.organization_postal_code}
                                    helperText={errors.organization_postal_code}
                                    fullWidth
                                />
                            </Grid>
                        </MDBox>
                        <MDBox mb={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="password"
                                    name="password"
                                    label="Password"
                                    variant="outlined"
                                    type={showPassword ? 'text' : 'password'}
                                    value={formData.password}
                                    onChange={handleChange}
                                    error={!!errors.password}
                                    helperText={errors.password}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleTogglePasswordVisibility}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" ml={-1}>
                            <Checkbox />
                            <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                            >
                                &nbsp;&nbsp;I agree the&nbsp;
                            </MDTypography>
                            <MDTypography
                                component="a"
                                href="#"
                                variant="button"
                                fontWeight="bold"
                                color="info"
                                textGradient
                            >
                                Terms and Conditions
                            </MDTypography>
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton variant="gradient" color="info" fullWidth onClick={handleRegister}>
                               {isLoading ? <CircularProgress  color="inherit"  size={20} /> : "Sign Up"}
                            </MDButton>
                        </MDBox>
                        <MDBox mt={3} mb={1} textAlign="center">
                            <MDTypography variant="button" color="text">
                                Already have an account?{" "}
                                <MDTypography
                                    component={Link}
                                    to="/"
                                    variant="button"
                                    color="info"
                                    fontWeight="medium"
                                    textGradient
                                >
                                    Sign In
                                </MDTypography>
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </CoverLayout>
    );
}

export default OrganizationRegister;
